import { deleteDoc, doc } from "firebase/firestore";
import Failure from "../../../core/Failure";
import { firestore } from "../../../firebase.config";
import { UserRole } from '@leedpulse-monorepo/enums';
import { Authentication } from '@leedpulse-monorepo/classes';
import { IPlan } from '@leedpulse-monorepo/interfaces';
import { FIREBASE_COLLECTIONS } from "@leedpulse-monorepo/consts";

async function deletePlan(
  planDoc: IPlan,
  auth: Authentication
): Promise<void> {
  if (![UserRole.owner, UserRole.admin].includes(auth.role)) {
    throw new DeletePlanFailure("Unauthorized", "unauthorized");
  }
  try {
    const planId = planDoc.id;
    await deleteDoc(doc(firestore, FIREBASE_COLLECTIONS.PLANS, planId));
    return;
  } catch (e) {
    console.log("error: ", e);
    throw new DeletePlanFailure();
  }
}

export class DeletePlanFailure extends Failure {
  constructor(message = "Unknown error", code = "unknown-error") {
    super(message, code);
  }
}

export default deletePlan;
